import React, { FC, ReactElement } from 'react';
import { EventCardComponentsProps } from './types';

type EventCardContainerProps = EventCardComponentsProps & {
  pageUrl: string | null;
};

const EventCardContainer: FC<EventCardContainerProps> = ({ children, className, pageUrl }): ReactElement => {
  const goToPage = () => { 
    if (pageUrl) {
      document.location.pathname = pageUrl;
    }
  };

  return (
    <div
      className={className}
      style={pageUrl ? {'cursor': 'pointer'} : {}}
      onClick={goToPage}
    >
      {children}
    </div>
  );
};

export { EventCardContainer };